import { useMemo } from 'react'

import { useGetEInvoicingKYCStatus } from '@features/eInvoicing/hooks/useGetEInvoicingKYCStatus'
import { Organization } from '@modules-deprecated/app/organization/types/organization'

export const useEInvoicingIntegration = (organization: Organization | undefined) => {
  const { data } = useGetEInvoicingKYCStatus({})

  const isEInvoicingEnabled = useMemo(() => organization?.countryId === 'FR', [organization?.countryId])
  const kycStatus = data?.status ?? (organization?.isCegid ? 'KYC_CREATED' : 'KYC_PENDING_DOCUMENTS')

  return { isEInvoicingEnabled, kycStatus }
}
